import { FunctionComponent, PropsWithChildren } from "react";
import { useRouter } from "next/router";
import { useAuth } from "@chordcommerce/react-autonomy";
import { AccountMenu } from "@bluebottlecoffee/design-system/components";
import { buildLocalizedUrl } from "../lib/link-builders";
import menu from "../lib/account-menu";
import { PageData } from "../lib/sanity/account-shared-queries";
import { LayoutWrapper } from "./LayoutWrapper";
import PrivatePage from "./PrivatePage";

type AccountPageProps = PropsWithChildren<PageData<Object>> & {
  pageTitle: string;
};

export const AccountPage: FunctionComponent<AccountPageProps> = ({
  children,
  pageTitle,
  ...layoutWrapperProps
}) => {
  const { asPath, push } = useRouter();
  const { accountMenuCopy, region, lang, aria } = layoutWrapperProps;
  const { logout } = useAuth();

  const url = buildLocalizedUrl({
    lang,
    region,
    path: "account",
  });

  return (
    <LayoutWrapper
      {...layoutWrapperProps}
      pageTitle={
        pageTitle
          ? `${pageTitle} | Blue Bottle Coffee Account`
          : "Account | Blue Bottle Coffee"
      }
    >
      <div style={{ minHeight: "50vh" }}>
        <PrivatePage region={region} lang={lang}>
          <AccountMenu
            menu={menu(region, lang, accountMenuCopy, logout)}
            currentPath={asPath}
            onButtonClick={() => push(url)}
            aria={{
              backButton: aria.backButtonAccount,
            }}
          >
            {children}
          </AccountMenu>
        </PrivatePage>
      </div>
    </LayoutWrapper>
  );
};
